import React, { Component } from 'react'
import axios from 'axios'
import { API_URL } from '../constants'
import { isEmpty, uniqBy, get, toUpper, capitalize, indexOf, flatMap, size, lowerCase, intersection } from 'lodash'
import qs from 'qs'
import {
  PageWrapper,
  Header,
  Card,
  FlexWrapper,
  Button,
  ProductViewWrapper,
  ProductView,
  PageLoader,
  SecondaryHeader
} from '../components'
import Cookies from 'js-cookie'
import { gsCalculator, priceRangeCalculator, isAdmin, filterHiddenData } from '../utlis/functions'

class ProductType extends Component {
  state = { loader: false, data: [], favroitesData: [], selectedStores: [] }
  async componentDidMount() {
    this.setState({ loader: true })
    await this.setState({ selectedStores: Cookies.getJSON('selectedStores') })
    await this.fetchWarningConflicts()
    await this.getFavouriteData()
    await this.fetchData()
    await this.setState({ loader: false })
  }

  fetchData = async () => {
    const selectedStoresFilter = !isEmpty(this.state.selectedStores)
      ? {
          and: [
            { productCategory: this.props.match.params.tab },
            { productType: { like: `%${this.props.match.params.tab1}%` } },
            {
              or: this.state.selectedStores.map(item => ({
                storeName: item
              }))
            }
          ]
        }
      : {
          and: [
            { productCategory: this.props.match.params.tab },
            { productType: { like: `%${this.props.match.params.tab1}%` } }
          ]
        }
    const query = {
      filter: {
        where: selectedStoresFilter,
        limit: 100,
        include: ['productCost', 'users']
      }
    }
    try {
      const { data } = await axios.get(`${API_URL}/product_cost_details`, { params: { filter: query.filter } })
      this.setState({ data: uniqBy(data, 'productCode') })
    } catch (error) {
      this.setState({ loader: false })
      console.log(error)
    }
  }

  fetchWarningConflicts = async () => {
    const warningQuery = {
      filter: { include: ['diets', 'allergies'] }
    }
    try {
      const { data } = await axios.get(`${API_URL}/users/${Cookies.get('user_id')}?${qs.stringify(warningQuery)}`)
      this.setState({ userData: data })
    } catch (error) {
      this.setState({ loader: false })
      console.log('ERROR', error)
    }
  }

  getFavouriteData = async () => {
    try {
      const { data } = await axios.get(
        `${API_URL}/users/${Cookies.get('user_id')}/productTables?filter=%7B%22fields%22%3A%22productCode%22%7D`
      )
      this.setState({ favouriteData: data })
    } catch (error) {
      this.setState({ loader: false })
      console.log('ERROR', error)
    }
  }
  changeFavouriteData = async id => {
    const query = {
      filter: {
        where: { userId: Cookies.get('user_id'), productCode: id }
      }
    }
    const { data } = await axios.get(`${API_URL}/UserProducts?${qs.stringify(query)}`)
    if (data.length === 0) {
      await axios.post(`${API_URL}/UserProducts`, {
        productCode: id,
        userId: Cookies.get('user_id')
      })
      await this.getFavouriteData()
    } else {
      await axios.delete(`${API_URL}/UserProducts/${data[0].id}`)
      await this.getFavouriteData()
    }
  }
  onStoreChange = () => {
    //get stores
    const selectedStores = Cookies.getJSON('selectedStores')
    // change state to the selected stores
    this.setState({ selectedStores }, this.componentDidMount)
    // change the filters
  }
  render() {
    const { favouriteData, data, userData, loader } = this.state
    const favouriteDataz = flatMap(favouriteData, 'productCode')
    const userDiets = get(userData, 'diets', []).map(item => lowerCase(item.diet))
    const userAllergies = get(userData, 'allergies', []).map(item => lowerCase(item.allergy))
    return (
      <React.Fragment>
        <Header
          title={capitalize(this.props.match.params.tab1)}
          icon="arrowBack"
          onClickBack={() => this.props.history.goBack()}
          color="#fff"
        />
        <SecondaryHeader clicked={this.onStoreChange} padding="70px 16px 0" />
        <PageWrapper viewPadding="18% 3.9% 6%" height="auto" modifyPadding="14px 16px 24px">
          {loader ? (
            <PageLoader />
          ) : isEmpty(filterHiddenData(data)) ? (
            <Card boxShadow="0 3px 6px 0 rgba(0, 0, 0, 0.16)" borderRadius="5px" bgColor="#fff">
              <FlexWrapper alignItems="center">
                <h3>No Best for you available</h3>
                <Button
                  type="submit"
                  label="View Products"
                  volume="filled"
                  margin="14px 10px 0"
                  size="small"
                  onClick={() => this.props.history.push('/products')}
                />
              </FlexWrapper>
            </Card>
          ) : (
            <ProductViewWrapper direction="row" flexWrap="wrap" justifyContent="space-between">
              {filterHiddenData(data).map(item => {
                const priceRange = get(item, 'productCost', []).map(range =>
                  range.productPriceSale ? range.productPriceSale : range.productPriceOriginal
                )
                const allergyConflicts = get(item, 'allergyConflicts', '')
                  .replace(/(\r\n\t|\n|\r\t|\r)/gm, '')
                  .toLowerCase()
                  .split(',')
                  .map(item => item.trim())
                const dietConflicts = get(item, 'dietConflicts', '')
                  .replace(/(\r\n\t|\n|\r\t|\r)/gm, '')
                  .toLowerCase()
                  .split(',')
                  .map(item => item.trim())
                return (
                  <ProductView
                    conflict={
                      !isEmpty(intersection(userAllergies, allergyConflicts)) ||
                      !isEmpty(intersection(userDiets, dietConflicts))
                    }
                    cardMargin="0 0 10px 0"
                    cardWidth="166px"
                    cardHeight="236px"
                    favValue={item.users ? item.users.length : 0}
                    key={item.id}
                    imageUrl={item.productImage}
                    quantity={
                      size(get(item, 'productQuantity', '')) < 15 ? toUpper(get(item, 'productQuantity', '')) : ''
                    }
                    productName={capitalize(item.productName)}
                    priceRange={priceRangeCalculator(priceRange)}
                    progressValue={Math.round(item.totalGs, 0)}
                    isFavorite
                    isHidden={isAdmin() && item.isHidden ? true : false}
                    favoriteActive={indexOf(favouriteDataz, item.productCode) === -1 ? false : true}
                    onFavorite={() => this.changeFavouriteData(item.productCode)}
                    onClick={() =>
                      this.props.history.push({
                        pathname: `/products/${item.productCode}/green-score`
                      })
                    }
                  />
                )
              })}
            </ProductViewWrapper>
          )}
        </PageWrapper>
      </React.Fragment>
    )
  }
}

export default ProductType



// WEBPACK FOOTER //
// ./src/pages/ProductType.js